import { MessagesSquareIcon, PillIcon, RefreshCwIcon } from 'lucide-react'

export const upcomingRxServices = [
  {
    title: 'Instant consultation',
    description: 'Speak with a care professional instantly.',
    icon: MessagesSquareIcon,
  },
  {
    title: 'Dawaak prescriptions',
    description: 'Manage connected prescriptions in one place.',
    icon: PillIcon,
  },
  {
    title: 'Medicine refill',
    description: 'Request a refill for your regular medicines.',
    icon: RefreshCwIcon,
  },
] as const
